import '../../../../../../components/skeletons/skeleton.css'
import { getHeaderHeroSkeletonStyle } from '../../../lumpsum/plans-list/lumpsum-ui-components/HeaderHeroSkeleton'
import {
  DEFAULT_SIP_ACTION_FILTERS,
  SIP_PLANS_ACTION_FILTERS_CLASS_NAME
} from '../header/common/ListSipActionFilters'

type SipHeaderHeroSkeletonProps = {
  backgroundColor: string
  isIdeal: boolean
}

export function SipHeaderHeroSkeleton({ backgroundColor, isIdeal }: SipHeaderHeroSkeletonProps) {
  const skeletonStyle = getHeaderHeroSkeletonStyle(backgroundColor)

  return (
    <>
      <div
        className={`relative overflow-visible px-5 ${isIdeal ? 'pt-8 pb-6' : 'pt-8 pb-4'}`}
        style={skeletonStyle}
      >
        <div className="relative z-[1] flex gap-3">
          <div className="min-w-0 flex-1 max-w-[240px]">
            <div className="skeleton h-[14px] w-[128px] rounded-[4px]" />
            <div className="skeleton mt-4 h-[28px] w-[200px] rounded-[4px]" />

            {!isIdeal ? (
              <div className="flex flex-col gap-1 pt-4">
                <div className="skeleton h-[14px] w-[188px] rounded-[4px]" />
                <div className="skeleton h-[14px] w-[152px] rounded-[4px]" />
              </div>
            ) : null}

            <div className={`flex flex-col gap-1.5 ${isIdeal ? 'pt-4' : 'pt-5'}`}>
              <div className="skeleton h-[14px] w-full rounded-[4px]" />
              <div className="skeleton h-[14px] w-[88%] rounded-[4px]" />
            </div>

            {isIdeal ? <div className="skeleton mt-6 h-[14px] w-[196px] rounded-[4px]" /> : null}
          </div>
        </div>
      </div>
      {!isIdeal ? <SipActionFiltersSkeleton backgroundColor={backgroundColor} /> : null}
    </>
  )
}

export function SipActionFiltersSkeleton({ backgroundColor }: { backgroundColor: string }) {
  return (
    <div
      className={SIP_PLANS_ACTION_FILTERS_CLASS_NAME}
      style={getHeaderHeroSkeletonStyle(backgroundColor)}
    >
      <div className="relative z-[1] overflow-x-auto no-scrollbar overscroll-x-none px-5 pb-6 pt-1">
        <div className="flex w-max gap-[10px]">
          {DEFAULT_SIP_ACTION_FILTERS.map((filterOption) => (
            <div
              key={filterOption}
              className="flex w-[58px] shrink-0 flex-col items-center gap-3"
            >
              <div className="skeleton h-12 w-12 rounded-full" />
              <div className="skeleton h-[12px] w-[48px] rounded-[4px]" />
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
